import component from "./Checkbox";

export default component;
